import Head from 'next/head'

import * as S from './Header.styles'

const defaultProps = {}
const propTypes = {}

export const Header = () => {
  const canAMQ = true
  // const canAMQ =
  //   user?.profile?.allowAMQ ||
  //   (user?.isProfileComplete && user?.profile?.karma > 50)

  return (
    <S.Container>
      <Head>
        <title>TSN - Questions</title>
      </Head>
      <S.Content>
        <S.Title>Questions</S.Title>
        {canAMQ && (
          <S.ButtonContainer>
            <S.AskQuestionButton />
          </S.ButtonContainer>
        )}
      </S.Content>
    </S.Container>
  )
}

Header.defaultProps = defaultProps
Header.propTypes = propTypes

export default Header
